// Copyright (c) Docugami, Inc. All rights reserved.

import { DirectionalHint, TooltipHost } from "@fluentui/react";
import { primaryTheme } from "components/shell/presentation/AppStyles";
import styled from "styled-components";
import { IItemSlotMarker } from "./ItemSlot";

const SlotFlagRoot = styled.div<{ color: string }>`
    background-color: ${props => props.color};
    font-size: 10px;
    line-height: 14px;
    height: 14px;
    width: 14px;
    text-align: center;
    color: ${primaryTheme.palette.white};
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
`;

export const ItemSlotMarker = (props: { info: IItemSlotMarker }): JSX.Element => {
    return (
        <TooltipHost content={props.info.tooltip} directionalHint={DirectionalHint.leftCenter}>
            <SlotFlagRoot color={props.info.color}>{props.info.icon}</SlotFlagRoot>
        </TooltipHost>
    )
}
